export default __webpack_public_path__ + "static/media/desert-bg.a05207df.png";